module.exports = __webpack_public_path__ + "img/back.9df7aaf3.jpg";